import { LottieSizeTokens, } from '@voltmoney/schema';
export const lottieSizeTokensMap = {
    [LottieSizeTokens.Size20]: 20,
    [LottieSizeTokens.XS]: 24,
    [LottieSizeTokens.Size28]: 28,
    [LottieSizeTokens.SM]: 36,
    [LottieSizeTokens.MD]: 48,
    [LottieSizeTokens.Size_56]: 56,
    [LottieSizeTokens.Size_96]: 96,
    [LottieSizeTokens.LG]: 72,
    [LottieSizeTokens.Size_80]: 80,
    [LottieSizeTokens.XL]: 96,
    [LottieSizeTokens.XXL]: 128,
    [LottieSizeTokens.Size_140]: 140,
    [LottieSizeTokens.XXXL]: 180,
    [LottieSizeTokens.Size_240]: 240,
    [LottieSizeTokens.Size_560]: 560,
    [LottieSizeTokens.Size_312]: 312,
    [LottieSizeTokens.FULL]: '100%',
};
